import React, {useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MyRangeInput from '../../MyRangeInput'
import HelpSettingPreferences from './HelpSettingPreferences'
import HelpSubNodes from './HelpSubNodes'
import HelpMoreData from './HelpMoreData'
import HelpIntroduction from './HelpIntroduction'
import HelpFeedback from '../HelpFeedback'
import HelpContext from './HelpContext'
import DialogChain from '../../dialogs/DialogChain'

export default function HelpTree(props){
  const titles = ["Introduction", "Setting Your Preferences", "Sub Nodes" ,"Get More Data", "Prefernce Examples", "Sharing Feedback"]
  const helpDialogs = [HelpIntroduction, HelpSettingPreferences, HelpSubNodes, HelpMoreData, HelpContext, HelpFeedback,]
  return (
    <DialogChain
      titles={titles}
      dialogs={helpDialogs}
      handleClose={props.handleClose}
      open={props.open}/>
  );


}
